// ======================================================================
// FILE:
// src/modules/service_crm/feedback/components/FeedbackKpiBar.js
//
// MODULE: Service CRM
// FEATURE: Feedback KPI Bar
// ======================================================================

import React from "react";

export default function FeedbackKpiBar({
  rows = [],
}) {

  const totalResolved =
    rows.length;

  const pending =
    rows.filter(
      (x) =>
        x.feedback_status ===
        "PENDING"
    ).length;

  const completed =
    rows.filter(
      (x) =>
        x.feedback_status ===
        "COMPLETED"
    ).length;

  const avgFeedback = (() => {

    const completedRows =
      rows.filter(
        (x) =>
          x.feedback_percentage
      );

    if (
      completedRows.length === 0
    ) {
      return 0;
    }

    const total =
      completedRows.reduce(

        (sum, row) =>
          sum +
          Number(
            row.feedback_percentage ||
            0
          ),

        0
      );

    return Math.round(
      total /
      completedRows.length
    );

  })();

  const cards = [

    {
      title:
        "Resolved Tickets",

      value:
        totalResolved,

      color:
        "#0d6efd",

      icon:
        "📋",
    },

    {
      title:
        "Pending Feedback",

      value:
        pending,

      color:
        "#fd7e14",

      icon:
        "⏳",
    },

    {
      title:
        "Completed Feedback",

      value:
        completed,

      color:
        "#198754",

      icon:
        "✅",
    },

    {
      title:
        "Avg Feedback",

      value:
        `${avgFeedback}%`,

      color:
        "#6f42c1",

      icon:
        "⭐",
    },
  ];

  return (

    <div

      style={{

        display: "grid",

        gridTemplateColumns:
          "repeat(auto-fit,minmax(220px,1fr))",

        gap: 16,

        marginBottom: 20,
      }}
    >

      {cards.map((card) => (

        <div

          key={card.title}

          style={{

            background: "#fff",

            borderRadius: 14,

            padding: 18,

            boxShadow:
              "0 2px 8px rgba(0,0,0,0.08)",

            borderTop:
              `4px solid ${card.color}`,
          }}
        >

          <div

            style={{

              display: "flex",

              justifyContent:
                "space-between",

              alignItems:
                "center",
            }}
          >

            <div>

              <div

                style={{

                  fontSize: 12,

                  color: "#6c757d",

                  marginBottom: 6,
                }}
              >
                {card.title}
              </div>

              <div

                style={{

                  fontSize: 28,

                  fontWeight: 700,
                }}
              >
                {card.value}
              </div>

            </div>

            <div

              style={{

                fontSize: 28,
              }}
            >
              {card.icon}
            </div>

          </div>

        </div>

      ))}

    </div>
  );
}